import React from "react";
import { ReactComponent as Ball } from "../../../assets/img/ball.svg";
import { Body, Span, NumberDay, InfoEvent, HeaderEvent, ContentEvent, SpanCity, Month } from "./styles";
import { defineMonth } from "../../../helpers/sharedHelper";
export default function CardEvents({
  city,
  cityName,
  countryId,
  date,
  eventIsOnHolding,
  selected,
  requestEventsInfo
}) {
  return (
    <Body selected={selected} onClick={requestEventsInfo}>
      <HeaderEvent>
        <Ball />
        <Span size="1rem">
          Evento Presencial
        </Span>
      </ HeaderEvent>
      <ContentEvent>
        <SpanCity>{cityName}</SpanCity>
        <InfoEvent>
          {eventIsOnHolding ? null : <NumberDay>{date.split("-")[2]}</NumberDay>}
          <Month transform="uppercase" size="1.5em">{defineMonth(date.split("-")[1])}</Month>
        </InfoEvent>
      </ContentEvent>
    </Body>
  );
}
